
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export function useGuestPermissions() {
  const { user } = useAuth();
  
  // Function to check if user is authenticated and show appropriate message if not
  const requireAuth = (action: string): boolean => {
    if (!user) {
      toast.error(`Please sign in to ${action}`, {
        description: "Create an account or sign in to continue",
        action: {
          label: "Sign In",
          onClick: () => {
            // You could add logic here to open the auth modal
            document.dispatchEvent(new CustomEvent("open-auth-modal"));
          }
        }
      });
      return false;
    }
    return true;
  };
  
  return { requireAuth };
}
